import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSubscription } from '../../contexts/SubscriptionContext';
import LoadingSpinner from '../shared/LoadingSpinner';

// Wraps the staff app routes. Sends unsubscribed medical_practice users to
// /app/subscribe; everyone else (paid org, law_firm, platform admin) passes
// through. Allows /app/subscribe and /app/settings even without sub so users
// can complete checkout or open the billing portal.
export default function SubscriptionGate() {
  const { needsSubscription, loading } = useSubscription();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center bg-primary">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // /app/welcome is exempt because the subscription webhook can land seconds
  // after Stripe redirects the user back — without exemption, the gate would
  // bounce them to /app/subscribe before the local cache catches up.
  const exempt =
    location.pathname === '/app/subscribe' ||
    location.pathname === '/app/settings' ||
    location.pathname === '/app/welcome';

  // TEMP: gate disabled. The subscription endpoint was returning a state
  // the frontend interpreted as "no active sub" even when one existed,
  // causing infinite-loop redirects to /app/subscribe. Until that's
  // properly diagnosed (network tab walk-through), the gate is a no-op.
  // To re-enable, replace `false` with `needsSubscription` below.
  // eslint-disable-next-line no-unused-vars
  const _gateOn = needsSubscription;
  if (false && needsSubscription && !exempt) {
    return <Navigate to="/app/subscribe" replace />;
  }
  return <Outlet />;
}
